import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { HelpArticleListParams } from '../api/help-center-api';
import { HELP_ARTICLE_FILTER_FIELDS, HELP_ARTICLE_SORTS } from '../components/help-article-filters';

/** URL search params of the articles list; mirrors GET /admin/v1/stores/{storeId}/help/articles. */
export const helpArticleListSearchSchema = indexSearchSchema(HELP_ARTICLE_FILTER_FIELDS, {
  sort: HELP_ARTICLE_SORTS,
});

export type HelpArticleListSearch = z.infer<typeof helpArticleListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function helpArticleListParams(search: HelpArticleListSearch): HelpArticleListParams {
  return listParams(search, HELP_ARTICLE_FILTER_FIELDS);
}
